<template>
    <div>
        <AlertDismiss ref="alertDismiss"></AlertDismiss>
        <div class="row">
            <div class="col-sm-12 mb-3">
                <b-form-group
                  label="Pregunta"
                  label-for="descripcionFormControlInput"
                >
                  <b-form-textarea
                    id="descripcionFormControlInput"
                    v-model="description"
                    placeholder="Ingrese una descripción para la pregunta"
                    rows="3"
                    max-rows="6"
                    :state="validate(description)">
                  ></b-form-textarea>
                </b-form-group>
            </div>

            <div class="col-sm-12 mb-3">
                <b-form-group label="Tipo de pregunta">
                    <b-form-select
                        class="form-control"
                        v-model="selectedTipo"
                        :options="options"
                        :state="validate(selectedTipo)"
                    >
                        <template #first>
                            <option value="" disabled>-- Selecciona una Tipo --</option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </div>


        </div>

        <div class="col-sm-6 mb-3">
            <b-form-checkbox
                v-model="requerido"
                name="some-radios"
                :state="validate(requerido)"
            >
                La pregunta es obligatoria
            </b-form-checkbox>
        </div>

        <button v-on:click="crear()" type="button" :disabled="isUploading" class="btn btn-primary">
            <b-spinner v-if="isUploading" small></b-spinner>
            Crear
        </button>

    </div>
</template>
<script>
import { mapActions } from 'vuex';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { EventNames } from '@/plugins/enums/index.js'
import { validateNonEmpty } from '@/plugins/complianceScripts';

export default {
    name: 'TypeDenounceForm',

    data() {
        return {
            description: '',
            requerido: true,
            selectedTipo: "",
            options: [
                { value: 'text', text: 'Texto' },
                { value: 'number', text: 'Número' },
                { value: 'date', text: 'Fecha' }
            ],
            attemptedSubmit: false,
            isUploading: false
        }
    },

    components: {
        AlertDismiss
    },

    methods: {
        validate(value) {
            return validateNonEmpty(value, this.attemptedSubmit);
        },
        ...mapActions(["createQuestion"]),

        clear() {
            this.description = "";
            this.tipo = "";
            this.requerido = true;
            this.selectedTipo = "";
        },

        async crear() {
            const data = {
                description: this.description,
                type: this.selectedTipo,
                required: this.requerido
            };

            this.isUploading = true;

            this.attemptedSubmit = true

            let result = await this.createQuestion(data);

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                this.isUploading = false;
                return;
            }
            this.isUploading = false;
            this.attemptedSubmit = false;

            this.$eventBus.$emit(EventNames.CreatedQuestion, result);

            this.clear();
            this.$refs.alertDismiss.showAlert('Creado correctamente', 'success');
        }
    },

}
</script>
<style></style>
